import { useCallback } from 'react';
import { useActive, useChainedCommands, useCommands } from '@remirror/react';

export const useUnderlineCommand = () => {
  const active = useActive();
  const { toggleUnderline } = useCommands();
  const chain = useChainedCommands();

  const toggle = useCallback(() => {
    chain
      .toggleUnderline()
      .focus()
      .run();
  }, [chain]);

  return {
    active: active.underline(),
    toggle,
    enabled: toggleUnderline.enabled(),
  };
};